import { useEffect } from "react";

interface SEOData {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  schema?: Record<string, unknown>;
}

interface SEOProps {
  data: SEOData;
}

export default function SEO({ data }: SEOProps) {
  const {
    title,
    description,
    keywords,
    canonicalUrl,
    ogType = "website",
    schema,
  } = data;

  const fullTitle = `${title} - 福利导航`;

  useEffect(() => {
    document.title = fullTitle;
    updateMeta("description", description);
    updateMeta("keywords", keywords);
    updateLink("canonical", canonicalUrl);
    updateMeta("og:title", fullTitle);
    updateMeta("og:description", description);
    updateMeta("og:type", ogType);
    updateMeta("og:url", canonicalUrl);
    updateMeta("twitter:title", fullTitle);
    updateMeta("twitter:description", description);
  }, [fullTitle, description, keywords, canonicalUrl, ogType]);

  return schema ? (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema, null, 0) }}
    />
  ) : null;
}

function updateMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"], meta[property="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    if (name.startsWith("og:") || name.startsWith("twitter:")) {
      el.setAttribute("property", name);
    } else {
      el.setAttribute("name", name);
    }
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function updateLink(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}